module.exports = __webpack_public_path__ + "static/media/offers.30815326.png";